import { render } from "./ticketCard.vue?vue&type=template&id=3d71458a&ts=true"
import script from "./ticketCard.vue?vue&type=script&lang=ts"
export * from "./ticketCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__